import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

export interface NotificationToastData {
  message: string;
  notificationId: number;
}

@Component({
  selector: 'app-notification-toast',
  standalone: true,
  imports: [MatButtonModule, MatIconModule],
  templateUrl: './notification-toast.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './notification-toast.component.scss'
})
export class NotificationToastComponent {
  constructor(
    public snackBarRef: MatSnackBarRef<NotificationToastComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: NotificationToastData
  ) {}

  markAsRead() {
    this.snackBarRef.dismissWithAction();
  }

  dismiss() {
    this.snackBarRef.dismiss();
  }
}
